// @ts-nocheck
// TODO: tighten types after migration
import { useCallback, useRef, useState } from "react";

type UseCopyFeedbackOptions = {
  resetDelayMs?: number;
};

export default function useCopyFeedback(options?: UseCopyFeedbackOptions) {
  const resetDelayMs = options?.resetDelayMs ?? 1500;
  const [isCopied, setIsCopied] = useState(false);
  const resetTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const copyText = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      if (resetTimer.current) {
        clearTimeout(resetTimer.current);
      }
      resetTimer.current = setTimeout(() => {
        setIsCopied(false);
      }, resetDelayMs);
      return true;
    } catch {
      setIsCopied(false);
      return false;
    }
  }, [resetDelayMs]);

  return {
    isCopied,
    copyText,
  };
}
